import { Layout } from '@/utils/routerHelper'


const workflowRouter = {
  path: '/workflow',
  component: Layout,
  alwaysShow: true, // will always show the root menu
  name: 'M_WORKFLOW',
  meta: {
    title: '流程审批',
    icon: 'ep:document'
  },
  children: [
    {
      path: 'workflow-list',
      component: () => import('@/views/workflow/index.vue'),
      name: 'M_WORKFLOW_LIST',
      meta: {
        title: '流程审批',
        icon: 'ep:checked'
      }
    },
    {
      path: 'workflow-detail/:id',
      component: () => import('@/views/workflow/workflow-detail.vue'),
      name: 'P_WORKFLOW_DETAIL',
      meta: {
        hidden: true,
        title: '流程详情',
        activeMenu: '/workflow/workflow-list',
      },
    },

  ]
}

export default workflowRouter
